import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from 'react-router-dom';
import { useNotification } from 'config/Notification';
import { ScrollContainer } from "react-nice-scroll";
import { Button, Card, ListGroup } from 'react-bootstrap';

import { fetchTopAlerts as fetchTopAlertsService } from 'services/modules/vapt/alert';
import { setTopAlerts} from  'stores/modules/vapt/alertreducer';

const SignificantThreats = (props) => {
  // Redux dispatch
  const dispatch = useDispatch();

  // React router
  const navigate = useNavigate();
  const location = useLocation();

  // Notification
  const {openNotification}=useNotification();

  // query params
  const searchParams = new URLSearchParams(location.search);
  const category = searchParams.get("category");

  const categoryId=props?.categoryId

  const dimension = searchParams.get("dimension");
  let categorySlug = "";
  if(!dimension)
    categorySlug="over-all"
  else
  categorySlug=dimension;

  // State variables
  const [criticalThreats, setCriticalThreats] = useState([]);
  const [highThreats, setHighThreats] = useState([]);
  const [mediumThreats, setMediumThreats] = useState([]);
  let severityName = (category === "compliance" ? true : false);

  // Redux selectors
  const reportDateContainer = useSelector((state) => state.vaptReport.latestReportDate);
  const selectedCompanyContainer = useSelector((state) => state.auth.companyData);
  const topAlertsContainer = useSelector((state) => state.vaptAlert.topalerts);
  const vaptDimensionsContainer = useSelector(state => state.vaptData.vaptDimensions);
  
  // useEffect hook fetches all the top alerts based on category
  useEffect(() => {
    if (reportDateContainer && (vaptDimensionsContainer.length > 0) && props?.category!=='' && props?.subcategory !==null) {
      fetchSignificantThreatsData();
    } else {
      dispatch(setTopAlerts([]));
      setCriticalThreats([]);
      setMediumThreats([]);
      setHighThreats([]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [reportDateContainer, category, vaptDimensionsContainer,dimension]);
  
 
  const fetchSignificantThreatsData = async () => {
    setCriticalThreats([]);
    setMediumThreats([]);
    setHighThreats([]);

    try{
      let params = {
        "domain": selectedCompanyContainer.domain,
        "date": reportDateContainer,
        "category":props?.categoryId,
        "subcategory":props?.subcategory
      };
      const vaptCategories = vaptDimensionsContainer?.map((cat)=>cat.slug);
      if (vaptCategories.includes(category)  && dimension !== null ) {
        const categories = vaptDimensionsContainer?.find(cat => cat.slug === category);
        const dimensions = categories?.Dimensions?.filter((dim)=>dim.slug === dimension).map((dim)=> dim.id)
        params.dimension = dimensions[0];
      }
     dispatch(fetchTopAlertsService({ params }));
   
    }catch(error){
      openNotification('Error while fetching alerts','error')
    }
    
  };

  // useEffect hook sets the alerts to state variables 
  useEffect(() => {
    if (topAlertsContainer && reportDateContainer) {
      setCriticalThreats([]);
      setHighThreats([]);
      setMediumThreats([]);
      if (topAlertsContainer.critical && topAlertsContainer.critical.length > 0) {
        let critical = topAlertsContainer.critical;
        setCriticalThreats(critical);
      }
      if (topAlertsContainer.high && topAlertsContainer.high.length > 0) {
        let high = topAlertsContainer.high;
        setHighThreats(high);
      }
      if (topAlertsContainer.medium && topAlertsContainer.medium.length > 0) {
        let medium = topAlertsContainer.medium;
        setMediumThreats(medium);
      }
    }
    else{
      setCriticalThreats([]);
      setHighThreats([]);
      setMediumThreats([]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [topAlertsContainer]);
 
  // Handles navigation to single alert page
  function navigateSingleThreat(threat) {
    navigate(`/vapt/vulnerability/${threat.id}`);
  }

  // Handles navigation to alerts page
  function navigateThreats(threat) {
    const domain = selectedCompanyContainer?.domain || '';
    const url = `/vapt/category-threats-dashboard/category-threats?category=${categorySlug}&alert_severity=${threat}&domain=${domain}&date=${reportDateContainer}&categoryId=${categoryId}&subcategory=${props.subcategory}`;
    navigate(url);
  }

  return (
    <div>
      <ScrollContainer className="topalerts">
        <Card className="text-white rounded-10 topalerts">
          <Card.Body>
            <Card.Title>
              <div className="carousel-title text-white">Top VAPT issues found</div>
            </Card.Title>
            <Card.Text>
              <div className='topalerts-div'>
                <div className={severityName ? 'overAll-none' : 'overAll-active'}>
                  <div>
                    <div className="d-flex flex-wrap  items-center">
                      <div className="severity">
                        <img src='/assets/icons/critical.svg' alt="" className="significant-threats-font" />
                        Critical
                        {(!criticalThreats || criticalThreats.length === 0) ? (
                          <span className="text-h8 text-center text-tertiary">
                            No findings found
                          </span>
                        ) : null}
                      </div>
                      <div className="d-flex flex-grow-1 justify-content-end">
                        {criticalThreats && criticalThreats.length > 0 && (
                          <Button
                            variant="outline-light"
                            rounded
                            onClick={() => navigateThreats('Critical')}
                            className="default-text rounded-pill topalerts-button"
                          >
                            View all
                          </Button>
                        )}
                      </div>
                    </div>
                    <div>
                      {(criticalThreats && criticalThreats.length > 0) ? (
                        <ListGroup className='topalerts-listgroup'>
                          {criticalThreats.map((threat, index) => (
                            <div key={index}>
                              <ListGroup.Item action onClick={() => navigateSingleThreat(threat)}>
                                <div className="d-flex justify-content-between">
                                  <span>{threat.title}</span>
                                  <span className="font-weight-bold">{Number.parseFloat(threat.score).toFixed(2)}</span>
                                </div>
                              </ListGroup.Item>
                            </div>
                          ))}
                        </ListGroup>
                      ) : (
                        <div className="mt-3">
                          <hr className="my-2" />
                        </div>
                      )}
                    </div>
                  </div>
                  <div>
                    <div className="d-flex flex-wrap  items-center">
                      <div className="severity">
                        <img src='/assets/icons/high_priority.svg' alt="" />
                        High
                        {(!highThreats || highThreats.length === 0) ? (
                          <span className="text-h8 text-center text-tertiary">
                            No Findings Found
                          </span>
                        ) : null}
                      </div>
                      <div className="d-flex flex-grow-1 justify-content-end">
                        {highThreats && highThreats.length > 0 && (
                          <Button
                            variant="outline-light"
                            rounded
                            onClick={() => navigateThreats('High')}
                            className="default-text rounded-pill topalerts-button"
                          >
                            View all
                          </Button>
                        )}
                      </div>
                    </div>
                    <div>
                      {(highThreats && highThreats.length > 0) ? (
                        <ListGroup className='topalerts-listgroup'>
                          {highThreats.map((threat, index) => (
                            <div key={index}>
                              <ListGroup.Item action onClick={() => navigateSingleThreat(threat)}>
                                <div className="d-flex justify-content-between">
                                  <span>{threat.title}</span>
                                  <span className="font-weight-bold">{Number.parseFloat(threat.score).toFixed(2)}</span>
                                </div>
                              </ListGroup.Item>
                            </div>
                          ))}
                        </ListGroup>
                      ) : (
                        <div className="mt-3">
                          <hr className="my-2" />
                        </div>
                      )}
                    </div>
                  </div>
                  <div>
                    <div className="d-flex flex-wrap  items-center">
                      <div className="severity">
                        <img src='/assets/icons/medium.svg' alt="" />
                        Medium
                        {(!mediumThreats || mediumThreats.length === 0) ? (
                          <span className="text-h8 text-center text-tertiary">
                            No Findings Found
                          </span>
                        ) : null}
                      </div>
                      <div className="d-flex flex-grow-1 justify-content-end">
                        {mediumThreats && mediumThreats.length > 0 && (
                          <Button
                            variant="outline-light"
                            rounded
                            onClick={() => navigateThreats('Medium')}
                            className="default-text rounded-pill topalerts-button"
                          >
                            View all
                          </Button>
                        )}
                      </div>
                    </div>
                    <div>
                      {(mediumThreats && mediumThreats.length > 0) ? (
                        <ListGroup className='topalerts-listgroup'>
                          {mediumThreats.map((threat, index) => (
                            <div key={index}>
                              <ListGroup.Item action onClick={() => navigateSingleThreat(threat)}>
                                <div className="d-flex justify-content-between">
                                  <span>{threat.title}</span>
                                  <span className="font-weight-bold">{Number.parseFloat(threat.score).toFixed(2)}</span>
                                </div>
                              </ListGroup.Item>
                            </div>
                          ))}
                        </ListGroup>
                      ) : (
                        <div className="mt-3">
                          <hr className="my-2" />
                        </div>
                      )}
                    </div>
                  </div>
                </div>
                <div className={severityName ? 'compliance-active' : 'compliance-none'}>
                  <div>
                    <div className="d-flex flex-wrap  items-center">
                      <div className="severity">
                        <img src='/assets/icons/critical.svg' alt="" className="significant-threats-font" />
                        Non-Compliant
                        {(!criticalThreats || criticalThreats.length === 0) && (!highThreats || highThreats.length === 0) ? (
                          <span className="text-h8 text-center text-tertiary">
                            No findings found
                          </span>
                        ) : null}
                      </div>
                      <div className="d-flex flex-grow-1 justify-content-end">
                        {((criticalThreats && criticalThreats.length > 0) || (highThreats && highThreats.length > 0)) && (
                          <Button
                            variant="outline-light"
                            rounded
                            onClick={() => navigateThreats('Non-Compliant')}
                            className="default-text rounded-pill topalerts-button"
                          >
                            View all
                          </Button>
                        )}
                      </div>
                    </div>
                    <div>
                      {(criticalThreats && criticalThreats.length > 0) || (highThreats && highThreats.length > 0) ? (
                        <ListGroup className='topalerts-listgroup'>
                          {criticalThreats.map((threat, index) => (
                            <div key={index}>
                              <ListGroup.Item action onClick={() => navigateSingleThreat(threat)}>
                                <div className="d-flex justify-content-between">
                                  <span>{threat.title}</span>
                                  <span className="font-weight-bold">{Number.parseFloat(threat.score).toFixed(2)}</span>
                                </div>
                              </ListGroup.Item>
                            </div>
                          ))}
                          {highThreats.map((threat, index) => (
                            <div key={index}>
                              <ListGroup.Item action onClick={() => navigateSingleThreat(threat)}>
                                <div className="d-flex justify-content-between">
                                  <span>{threat.title}</span>
                                  <span className="font-weight-bold">{Number.parseFloat(threat.score).toFixed(2)}</span>
                                </div>
                              </ListGroup.Item>
                            </div>
                          ))}
                        </ListGroup>
                      ) : (
                        <div className="mt-3">
                          <hr className="my-2" />
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </Card.Text>
          </Card.Body>

        </Card>
      </ScrollContainer>
    </div>
  )
}

export default SignificantThreats;